// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import router from './router'
import router from './router'
import VueRouter from 'vue-router';
import store from './router/store'
// import 'vant/lib/vant-css/icon-local.css';
import axios from 'axios';

import {Toast} from 'vant';

import wx from 'weixin-js-sdk';
import _ from 'lodash';

import '@vant/touch-emulator';

/*
import Vconsole from 'vconsole'
let vConsole = new Vconsole()
export default vConsole
*/


global._ = _;

Vue.use(Toast)
// Toast.allowMultiple();

const globalConfig = {
  sbyUploader: true // 使用最新的上传组件
}

Vue.prototype.$cfg = globalConfig; 

Vue.config.productionTip = false

document.addEventListener('DOMContentLoaded', function() {
  if (window.FastClick) window.FastClick.attach(document.body);
}, false);

const requireComponent = require.context(
  // 其组件目录的相对路径
  './components',
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /sby[^.]+]*\.(vue|js)$/
)

// console.log("requireComponent", requireComponent);

// https://cn.vuejs.org/v2/guide/components-registration.html
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName)

  // 获取组件的 PascalCase 命名
  const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1')

  // console.log("准备注册组件", componentName);

  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  )
})


Vue.use(VueRouter)
Vue.prototype.$wx = wx;

function toastError(msg) {
  hideLoading();
  if (msg.includes('config')){//XXX 找到微信报错的真正原因 修复
    console.error("发生config错误", msg);
    return;
  }
  // Toast({type: 'html', message: msg});
  Toast(msg);
}



let loadingOptions = {
  duration: 0,       // 持续展示 toast
  forbidClick: true, // 禁用背景点击
  loadingType: 'spinner',
  mask: false,
  message: '处理中...'
}

let loadingToast = null;

function hideLoading() {
  if (loadingToast) {
    loadingToast.clear();
    loadingToast = null;
  }
}

function showLoading(mask = false) {
  if (!loadingToast) {
    loadingToast = Toast.loading(_.extend({}, loadingOptions, {mask: mask}));
  }
}

axios.interceptors.request.use((config = {})=> {
  //可以从config 获取url
  if (window.isBeta) {
    config.url = '/betaapi' + config.url;
  }
  if (config.loading) {
    hideLoading();
    showLoading();
  }
  return config;
}, err=> {
  toastError('请求超时!');
  return Promise.reject(err);
})
axios.interceptors.response.use(data=> {
  // hideLoading();
  let config = data.config || {};
  if (data.status && data.status === 200) {
    if (data.data.status === 'error') {
      toastError(data.data.msg);
      return Promise.reject(new Error(data.data.msg));
    }
    if (data.data.errno !== 0) {//表示有错误
      if (data.data.errno === 401) {
        if (config.ignoreAuthFail) {
          return;
        }
        store.commit('logout');
        router.push('/enter');//直接跳转到首页
        toastError(data.data.errmsg);
        return Promise.reject(new Error('你需要重新登录'));
      }
      if (typeof data.data.errmsg === 'string') {
      if (data.data.errno != 601) {
          toastError(data.data.errmsg);
          return Promise.reject(new Error(data.data.errmsg));
        }
      } else if (typeof data.data.errmsg === 'object') {
        const _ = require('lodash');
        let msg = _.values(data.data.errmsg)[0];
        toastError(msg );
        return Promise.reject(new Error(msg));
      }
    }
  }

  return data;
}, err=> {
  hideLoading();
  if (err.response.status == 504||err.response.status == 404) {
    Toast('服务器被吃了⊙﹏⊙∥');
  } else if (err.response.status == 403) {
    Toast('权限不足,请联系管理员!');
  }else {
    Toast('未知错误! 代码：' + err.response.status);
  }
  return Promise.reject(err);
})

Vue.prototype.$http = axios;

Vue.prototype.$showLoading = showLoading;
Vue.prototype.$hideLoading = hideLoading;

store.commit('initialiseStore');



/* eslint-disable no-new */
const vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
})


router.loadedCallback(vm);
// router.afterEach((to, _from) => {
//   console.log("当前路由变化, to: ", to, "from: ", _from, to.path, location.href);
//   // vm.$hideLoading();
// })


global.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js